import { useState, useEffect, useContext } from 'react';
import { Row, Col } from 'reactstrap';
import Header from '../../components/header';
import { getTickets } from '../../services/product';
import { Information } from '../../components/information';
import { useNavigate } from 'react-router-dom';
import { TransactionContext } from '../../contexts/TransactionContext';
import { useTranslation } from 'react-i18next';
import { Tickets } from '../../components/tickets';
import Progress from '../../components/progress';
import { EVENTID } from '../../helpers/constants';
import { Alert } from '../../components/modal';
import { useError } from '../../hooks/useError';
export const Cart = () => {
  const [t, i18n] = useTranslation();
  const navigate = useNavigate();
  const { cpSelected, setCart, firstStep } = useContext(TransactionContext);
  const [tickets, setTickets] = useState([]);
  const { goToFieldWithError } = useError();

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    goToFieldWithError('home-cp');
  };

  const updateTicketCount = (value, index, maxCount) =>
    setTickets((prevState) => {
      const newState = [...prevState];
      const currentCount = newState[index].count;
      const newCount = currentCount + value;
      if (
        newState[index] === undefined ||
        newCount > maxCount ||
        newCount < 0
      ) {
        return newState;
      }
      newState[index] = { ...newState[index], count: newCount };
      return newState;
    });

  const handleAddTicket = (e, index) => {
    const ticket = tickets[index];
    //console.log(ticket);

    const ticketInCart = tickets.find((x) => x.count > 0);

    if (!(ticketInCart && ticketInCart.id !== ticket.id)) {
      const isCartEmpty = tickets.every((ticket) => ticket.count === 0);
      const valueToAdd = isCartEmpty ? ticket.purchaseMin : 1;
      updateTicketCount(valueToAdd, index, ticket.purchaseMax);
    }
  };

  const handleRemoveTicket = (e, index) => {
    const ticket = tickets[index];
    const valueToAdd =
      ticket.count === ticket.purchaseMin ? -ticket.purchaseMin : -1;
    if (ticket.count > 0) {
      updateTicketCount(valueToAdd, index);
    }
  };

  const handleBuy = (e) => {
    e.preventDefault();
    const selectedTicket = tickets.find((ticket) => ticket.count > 0);

    // console.log(selectedTicket);
    // console.log(cpSelected.count);
    if (selectedTicket.count > cpSelected.count) {
      setMessage(
        `Quantidade de ingressos selecionados maior que a quantidade de ingressos disponíveis para o ${cpSelected.name}.`,
      );
      openModal();
      return;
    }
    const ticketToBuy = tickets.filter((ticket) => ticket.count > 0);
    if (ticketToBuy.length > 0) {
      setCart(ticketToBuy);
      navigate('/pagamento');
    }
  };

  useEffect(() => {
    const fetchTickets = async () => {
      i18n.changeLanguage('pt');
      document.documentElement.setAttribute('lang', t('language'));
      document.title = t('title');

      if (cpSelected?.code === '') {
        navigate('/');
      } else {
        const response = await getTickets(EVENTID);
        const newTickets = response.map((ticket) => ({
          ...ticket,
          count: 0,
        }));
        setTickets(newTickets);
        firstStep();
      }
    };
    fetchTickets();
  }, []);

  const modal = (
    <Alert
      isOpen={open}
      toggle={closeModal}
      message={message}
    />
  );

  return (
    <>
      {modal}
      <Header />
      <main
        className='site-wrap'
        id='home-cp'
      >
        <Progress
          current='tickets'
          t={t}
        />
        <Row className='g-4 g-lg-5'>
          <Col
            lg={{ size: 7, order: 1 }}
            xs={{ order: 2 }}
          >
            <Information t={t} />
          </Col>
          <Col
            lg={{ size: 5, order: 2 }}
            xs={{ order: 1 }}
          >
            <div className='glass site-sticky'>
              <Tickets
                handleAdd={handleAddTicket}
                handleRemove={handleRemoveTicket}
                handleBuy={handleBuy}
                tickets={tickets}
                t={t}
              />
            </div>
          </Col>
        </Row>
      </main>
    </>
  );
};
